import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { RouterProvider } from 'react-router-dom';
import './i18n';
import { LocaleProvider } from './i18n/LocaleProvider';
import { initAnalytics } from './lib/analytics';
import { fetchPublicConfig } from './lib/config';
import { router } from './router';
import './index.css';

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('#root not found');

// Fire-and-forget analytics init. Failures must never block app rendering.
fetchPublicConfig()
  .then(initAnalytics)
  .catch(() => {
    /* analytics is optional */
  });

createRoot(rootEl).render(
  <StrictMode>
    <LocaleProvider>
      <RouterProvider router={router} />
    </LocaleProvider>
  </StrictMode>,
);
